module.exports = __webpack_public_path__ + "img/ico-reports.de89618a.svg";